import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Css/account.css";
import { Breadcrumb, Button, Checkbox, Form, Input, message } from "antd";
import { MdOutlineEmail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import { BiLockOpen } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "../../features/authSlice";
import { setProfile, storeToken } from "../../services/localStorageServices";
import GoogleLogin from "react-google-login";
import { FaRegUser } from "react-icons/fa6";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { PRODUCT_API_BASE_URL, AUTH_API_BASE_URL } from "../../services/apiConfig";
import Logo from "../../Images/Logo/New Footer Logo.png";

export default function SignUp() {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const payload = {
        name: values.name,
        email: values.email,
        phone: values.phone,
        password: values.password,
        role: "customer", // Default role
      };

      const response = await axios.post(
        `${PRODUCT_API_BASE_URL}users/register`,
        payload
      );

      if (response.data?.success) {
        const { token, user, message: successMsg } = response.data;

        // Save to local storage
        storeToken(token);
        setProfile(user);

        // Update Redux state
        dispatch(setUserToken({ token }));

        message.success(successMsg || "Registered successfully.");
        navigate("/");
      } else {
        message.error(response.data?.message || "Registration failed");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "Registration failed"
      );
    } finally {
      setLoading(false);
    }
  };

  // Google Login configuration
  const clientId =
    "413735203093-tt019nmdfqqkff5vf69lhskudqtph6m0.apps.googleusercontent.com";

  const onSuccess = async (res) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("username", res.profileObj.name);
      formDataToSend.append("User_Email", res.profileObj.email);
      formDataToSend.append("action", "login");

      const response = await axios.post(
        `${AUTH_API_BASE_URL}Googlelogin.php?`,
        formDataToSend
      );

      if (response.data) {
        dispatch(setUserToken({ token: response.data.token }));
        storeToken(response.data.token);
        setProfile(response.data.profile);
        navigate("/");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onFailure = (res) => {
    console.log("LOGIN FAILED! res: ", res);
  };

  return (
    <div className="login-page">
      <div className="account-card signUp">
        <div className="card-header">
          <div className="logo-wrapper">
            <img src={Logo} alt="Company Logo" className="brand-logo" />
          </div>
          <Breadcrumb
            className="custom-breadcrumb"
            items={[
              {
                title: <Link to="/">Home</Link>,
              },
              {
                title: "Sign Up",
              },
            ]}
          />
        </div>

        <div className="account-form">
          <Form
            name="normal_login"
            className="login-form"
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            requiredMark={false}
          >
            <Form.Item
              name="name"
              label="Full Name"
              rules={[
                {
                  required: true,
                  message: "Please input your name!",
                },
              ]}
            >
              <Input
                prefix={<FaRegUser className="input-icon" />}
                placeholder="John Doe"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
                {
                  type: "email",
                  message: "Please enter a valid email!",
                },
              ]}
            >
              <Input
                prefix={<MdOutlineEmail className="input-icon" />}
                placeholder="name@example.com"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[
                {
                  required: true,
                  message: "Please input your phone no.!",
                },
                {
                  min: 10,
                  max: 10,
                  message: "Please enter a valid Phone!",
                },
              ]}
            >
              <Input
                prefix={<BsTelephone className="input-icon" />}
                placeholder="10-digit Phone Number"
                size="large"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password
                prefix={<BiLockOpen className="input-icon" />}
                placeholder="Create password"
                size="large"
                iconRender={(visible) =>
                  visible ? <FaRegEye /> : <FaRegEyeSlash />
                }
              />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="password2"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("The passwords do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<BiLockOpen className="input-icon" />}
                placeholder="Confirm password"
                size="large"
                iconRender={(visible) =>
                  visible ? <FaRegEye /> : <FaRegEyeSlash />
                }
              />
            </Form.Item>

            <div className="form-actions-row">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
            </div>

            <Form.Item style={{ marginTop: 20 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
                block
                size="large"
              >
                {loading ? "Signing up..." : "Sign Up"}
              </Button>
              <div className="register-text">
                Already have an account?{" "}
                <Link to="/account/sign-in" className="highlight-link">
                  Log in now
                </Link>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}